import _pt from "prop-types";
import React from "react";
import { Icon, OutlinedIcon, LayeredIcons } from "./icon";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


export var AppPushIcon = function AppPushIcon(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size,
      title = _ref.title,
      _ref$weight = _ref.weight,
      weight = _ref$weight === void 0 ? "" : _ref$weight,
      props = _objectWithoutProperties(_ref, ["className", "color", "size", "title", "weight"]);

  var mobileIcon = "mobile";
  var arrowLeftLongIcon = "arrow-left-long-regular";

  if (weight === "thin") {
    mobileIcon = "mobile-thin";
    arrowLeftLongIcon = "arrow-left-long";
  }

  return React.createElement(LayeredIcons, _extends({
    className: className,
    size: size,
    title: title
  }, props), React.createElement(Icon, {
    color: color,
    name: mobileIcon,
    size: size
  }), React.createElement(OutlinedIcon, {
    color: color,
    name: arrowLeftLongIcon,
    size: size,
    transform: "shrink-4 right-4 up-2"
  }));
};
AppPushIcon.propTypes = {
  className: _pt.string,
  color: _pt.string,
  size: _pt.oneOf(["small", "medium", "large"]).isRequired,
  title: _pt.string,
  weight: _pt.oneOf(["thin"])
};
export var WebPushIcon = function WebPushIcon(_ref2) {
  var className = _ref2.className,
      color = _ref2.color,
      size = _ref2.size,
      title = _ref2.title,
      weight = _ref2.weight,
      props = _objectWithoutProperties(_ref2, ["className", "color", "size", "title", "weight"]);

  var displayIcon = "display";
  var arrowLeftLongIcon = "arrow-left-long-regular";

  if (weight === "thin") {
    displayIcon = "display-thin";
    arrowLeftLongIcon = "arrow-left-long";
  }

  return React.createElement(LayeredIcons, _extends({
    className: className,
    size: size,
    title: title
  }, props), React.createElement(Icon, {
    color: color,
    name: displayIcon,
    size: size
  }), React.createElement(OutlinedIcon, {
    color: color,
    name: arrowLeftLongIcon,
    size: size,
    transform: "shrink-5.5 right-5 up-1.5"
  }));
};
WebPushIcon.propTypes = {
  className: _pt.string,
  color: _pt.string,
  size: _pt.oneOf(["small", "medium", "large"]).isRequired,
  title: _pt.string,
  weight: _pt.oneOf(["thin"])
};